import { RootAppState } from 'store/configureStore'

export const bomItemNotificationSelector =
  (bomItemId: string) => (state: RootAppState) => {
    return state.notifications.Notifications[bomItemId]
  }
